module.exports = __webpack_public_path__ + "img/tiktok.471f82d.png";